import React from 'react';

import * as api from '../api';
import * as PATH from '../index';
import { IError } from '../types';

export type BuyProductsInput = {
  priceIds: string[];
  courseFreeId?: string;
  newPaymentMethodId?: string;
  paymentMethodId?: string;
};

type BuyProductsResponse = {
  status: string;
};

export type BuyProducts = {
  status: string;
};

function resToResult(res: BuyProductsResponse): BuyProducts {
  return {
    status: res.status,
  };
}

export function useBuyProducts() {
  const [data, setData] = React.useState<BuyProducts | null>(null);
  const [error, setError] = React.useState<IError | null>(null);
  const [loading, setLoading] = React.useState<boolean>(false);

  async function buyProducts(input: BuyProductsInput) {
    const path = PATH.BUY_PRODUCTS;
    try {
      setLoading(true);
      const res: BuyProductsResponse = await api.post(path, { ...input });
      if (res.status === 'course-failed') {
        setLoading(false);
        setError({ error: true });
        return false;
      } else {
        setData(resToResult(res));
        setLoading(false);
        return true;
      }
    } catch (e) {
      setLoading(false);
      setError({ error: true });
      return false;
    }
  }

  return { data, error, loading, buyProducts };
}
